import posthog from "posthog-js";

const capture = (event, props) => setTimeout(() => posthog.capture(event, props), 0);

export const trackDefinitionViewed = ({ root, rawQuery, entryCount, nounCount } = {}) =>
  capture("definition_viewed", { root, raw_query: rawQuery, entry_count: entryCount, noun_count: nounCount });

export const trackRootNotFound = ({ root, rawQuery, hadSarfSuggestions } = {}) =>
  capture("root_not_found", { root, raw_query: rawQuery, had_sarf_suggestions: hadSarfSuggestions });

export const trackReportMissingRoot = ({ root } = {}) =>
  capture("missing_root_reported", { root });

export const trackBookmarkAdd = ({ root, totalBookmarks } = {}) =>
  capture("bookmark_added", { root, total_bookmarks: totalBookmarks });

export const trackFlashcardAdd = ({ root, collectionName, isNewCollection, collectionSize } = {}) =>
  capture("flashcard_added", { root, collection_name: collectionName, is_new_collection: isNewCollection, collection_size: collectionSize });

export const trackMilestoneReached = ({ milestone, milestoneLabel } = {}) =>
  capture("milestone_reached", { milestone, milestone_label: milestoneLabel });

export const trackGoogleSignIn = ({ platform } = {}) =>
  capture("user_signed_in", { method: "google", platform });

export const trackSettingChanged = ({ key, value } = {}) =>
  capture("setting_changed", { setting_key: key, setting_value: value });
